module.exports = __webpack_public_path__ + "img/add-user.5ce8ed80.svg";